var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M27.6316 2.52637H2.36842C1.02632 2.52637 0 3.55268 0 4.89479V19.1053C0 20.4474 1.10526 21.4737 2.36842 21.4737H27.6316C28.9737 21.4737 30 20.4474 30 19.1053V4.89479C30 3.55268 28.8947 2.52637 27.6316 2.52637Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6315 3.31592C28.5 3.31592 29.2105 4.02644 29.2105 4.89487V19.1054C29.2105 19.9738 28.5 20.6843 27.6315 20.6843H2.36838C1.49996 20.6843 0.789429 19.9738 0.789429 19.1054V4.89487C0.789429 4.02644 1.49996 3.31592 2.36838 3.31592H27.6315Z",
    fill: "#006FCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37793 18.1296V11.4814L18.2106 11.4917V13.328L16.8432 14.7901L18.2106 16.2641V18.1391H16.0269L14.8664 16.8586L13.7137 18.1438L6.37793 18.128V18.1296Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16797 17.3997V12.2129H11.5669V13.4074H8.59218V14.2189H11.4959V15.3937H8.59218V16.191H11.5669V17.3997H7.16797Z",
    fill: "#006FCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5449 17.4005L13.9789 14.8039L11.5449 12.2129H13.4286L14.916 13.8574L16.4081 12.2137H18.2104V12.2539L15.8286 14.8039L18.2104 17.3279V17.4013H16.3891L14.8757 15.741L13.3773 17.4021H11.5449V17.4005Z",
    fill: "#006FCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92895 5.58008H9.7821L10.7839 7.85455V5.58008H14.305L14.9129 7.28455L15.5216 5.58008H18.2105V12.2282H4L6.92895 5.58008Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46959 6.30225L5.16748 11.4859H6.74643L7.18064 10.4478H9.53327L9.96748 11.4859H11.5859L9.29327 6.30225H7.46959ZM7.66695 9.28409L8.35774 7.63409L9.04695 9.28409H7.66695Z",
    fill: "#006FCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.564 11.4853V6.30078L13.7832 6.30868L14.9263 9.49578L16.0758 6.30157H18.2105V11.4845L16.8369 11.4971V7.93657L15.539 11.4845H14.2837L12.9605 7.92473V11.4853H11.5648H11.564Z",
    fill: "#006FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.d220136c890a1eec36b5b57f2cdbd8d4.svg";
export { ForwardRef as ReactComponent };